import { CeresFeaturesConfig } from './interfaces/ceres-features-config.interface';

const FEATURES: CeresFeaturesConfig = {
    timeManagement: {
        enabled: true,
        timeSheets: true,
        transactionalTimeTracking: false,
        capacity: true,
        absences: true,
        workload: true,
        disableTimeSheetsOption: true,
        timesheetMonthClose: true
    },
    businessPartner: {
        enabled: true
    },
    sales: {
        enabled: true,
        businessOpportunities: true,
        salesActivities: false,
        salesFunnel: false,
        offers: true,
        offersV2: false
    },
    projects: {
        enabled: true,
        copyExistingProject: true,
        copyExistingProjectWithChildren: true,
        orcChecker: false,
        inheritance: true,
        groups: {
            enabled: true,
            statusReports: false,
            classification: false
        },
        charging: true,
        timesheetLock: true,
        chargingCopyProposalBillingValue: false,
        nrsView: true,
        preStaffing: false,
        projectValueInheritance: true,
        restrictTimesheetFavoritesToAssignedProjects: true,
        projectSharedCosts: false
    },
    reporting: {
        enabled: true,
        dataQuality: true,
        pulseDashboard: true,
        costReport: true,
        workingHoursReport: true,
        absenceReport: true,
        gmsReportingDemo: false,
        productivityReport: true
    },
    employees: {
        enabled: true,
        experiences: false,
        multiRole: true
    },
    faq: {
        enabled: true
    },
    ticketTool: {
        enabled: true
    },
    administration: {
        enabled: true,
        servicePackages: false,
        departments: false,
        serviceProducts: false,
        orgIds: false,
        experiences: false,
        juno: false,
        customerPspElements: false,
        globalNotifications: false
    },
    services: {
        enabled: false,
        documents: false
    },
    scheduling: {
        enabled: false,
        scheduler: false,
        analytics: false,
        unrestrictedAccess: false
    },
    global: {
        currencyConversion: false,
        darkMode: true,
        sharepoint: true
    },
    sharepointExport: {
        enabled: true
    },
    pocReminder: {
        enabled: false
    },
    projectConfirmation: {
        enabled: false
    },
    documentCategorization: {
        enabled: true
    }
};

export default FEATURES;
